import React, { createContext, useState, useEffect, useContext } from "react";
import { AuthContext } from "./AuthContext";
import { fetchRailroadOperators } from "../services/authAPI"; // You'll need to create this API function

export const RailroadOperatorContext = createContext();

export const RailroadOperatorProvider = ({ children, token }) => {
  const [railroadOperators, setRailroadOperators] = useState([]);
  const [loading, setLoading] = useState(true);
  const { setGlobalError, apiConfigured, resetTrigger, refreshTrigger } = useContext(AuthContext);

  useEffect(() => {
    const fetchRailroadOperatorsCall = async () => {
      if (!apiConfigured) {
        console.warn('Railroad Operator Context: API not yet configured, skipping fetch');
        return;
      }
      try {
        const operators = await fetchRailroadOperators();
        setRailroadOperators(operators);
      } catch (err) {
        console.error("Error fetching railroad operators:", err);
        setGlobalError("Failed to fetch railroad operators");
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      fetchRailroadOperatorsCall();
    } else {
      setLoading(false);
    }
  }, [token, setGlobalError, apiConfigured, refreshTrigger]);

  // Watch for reset trigger from AuthContext
  useEffect(() => {
    if (resetTrigger > 0) {
      resetRailroadOperators();
    }
  }, [resetTrigger]);

  // Watch for refresh trigger from AuthContext (for account switching)
  useEffect(() => {
    if (refreshTrigger > 0 && token && apiConfigured) {
      setLoading(true);
      const fetchRailroadOperatorsCall = async () => {
        try {
          const operators = await fetchRailroadOperators();
          setRailroadOperators(operators);
        } catch (err) {
          console.error("Error fetching railroad operators:", err);
          setGlobalError("Failed to fetch railroad operators");
        } finally {
          setLoading(false);
        }
      };
      fetchRailroadOperatorsCall();
    }
  }, [refreshTrigger, token, apiConfigured, setGlobalError]);

  const resetRailroadOperators = () => {
    setRailroadOperators([]);
    setLoading(true);
  };

  return (
    <RailroadOperatorContext.Provider value={{ railroadOperators, loading, resetRailroadOperators }}>
      {children}
    </RailroadOperatorContext.Provider>
  );
};
